import React, { Component } from "react";
import {
  Row,
  Col,
  DatePicker,
  Spin,
  Tooltip,
  Space,
  Tag,
  Select,
  Modal as modal,
  Space as space,
  Button as button,
  Pagination,
  Tabs,
} from "antd";
import PrimaryButton from "../CommonComponent/Buttons/PrimayButton";
import { Form } from "@ant-design/compatible";
// import { Select } from 'antd';
import TableData from "../../components/ClaimsSearch/TableData";
import "./Reports.css";
import blackscreen from ".././images/No_Reports.svg";
import Report_Home from ".././images/Report_Home.svg";
import UltimateLogo from ".././images/ReportLogos/UltimateLogo.png";
import mirranew from ".././images/new_mirra_logo.png";
import Config from "../../config";
import axios from "axios";
import ExportJsonExcel from "js-export-excel";
import jsPDF from "jspdf";
import "jspdf-autotable";
import CreateTicket from "../TicketManagement/CreateTicket/CreateTicket";
import PDFContent from "./PDFContent";
import Pdf from "react-to-pdf";
import moment from "moment";
import MemberCard from "../memberSearch/searchMemberCard";
import Rosterreport from"./RosterReport"
import AdditionalReports from "./AdditionalReports";
const ref = React.createRef();
const { Option } = Select;



class Reports extends Component {
  constructor(props) {
    super(props);
   
    this.state = {
      Fromwhere: "Report",
      TicketShow: false,
      reportLoading: false,
      selProviders: [],
      selpayeename: [],
      providerLoader: false,
      payeeLoader: false,
      selIpaNames: [],
      ipaNameList: [],
      providernameList: [],
      payeenameList: [],
      showFound: false,
      GroupOrIpaField: true,
      pcpReport: null,
      isLoading: false,
      startDate: "",
      endDate: "",
      rowsPerPage: 15,
      currentPage: 1,
      totalrecored: 0,
      enableGenrateButton: false,
      selectedIapname: [],
      activeKeydata:1
    };
  }

  getpaginationData = (allRows, currentPage) => {
    // console.log(this.state.totalrecored)
    // console.log(allRows)
    // console.log(currentPage)
    const indexOfLastRow = currentPage * this.state.rowsPerPage;
    // console.log(indexOfLastRow)
    const indexOfFirstRow = indexOfLastRow - this.state.rowsPerPage;
    const currentPageData = allRows.slice(indexOfFirstRow, indexOfLastRow);
    return currentPageData;
  };
  onPageChange = (page, pageSize) => {
    const newTotalRecored = (page - 1) * pageSize;
    this.setState(
      {
        currentPage: page,
        totalrecored: newTotalRecored,
      },
      () => {
        // Code to execute after state update and component re-render
        //console.log("State has been updated:", this.state.totalrecored);
      }
    );
  };

  handleReset = () => {
    this.props.form.resetFields();
    // this.getipaNameList(true);
    // ===================== CHANGE =====================
    // Removed the unconditional `this.getipaNameList(true)` from here.
    // It is now called after the state reset (see the setState callback below),
    // using the same role logic as componentDidMount.
  
    this.setState({
      // showFound: false,
      providernameList:
        sessionStorage.getItem("planName") === "solis"
          ? this.state.providernameList
          : [],
      pcpReport: null,
      selProviders: [],
      payeenameList: [],
      selIpaNames: [],
      selpayeename: [],
      startDate: "",
      endDate: "",
      rowsPerPage: 15,
      currentPage: 1,
      totalrecored: 0,
      enableGenrateButton: false,
     },
      () => {
        // ===================== CHANGE =====================
        // Reload the dropdown data AFTER the state is cleared, mirroring
        // componentDidMount:
        //  - Provider (or Group User on non-ultimate plans, where the IPA field
        //    is hidden) -> getProviderNameList() -> ListNPIBasedOnPlan
        //  - everyone else -> getipaNameList(true) as before
        const roles = sessionStorage.getItem("rolename") || "";
        if (
          roles.includes("Provider") ||
          (sessionStorage.getItem("planName") !== "ultimate" &&
            roles.includes("Group User"))
        ) {
          this.getProviderNameList();
        } else {
          this.getipaNameList(true);
        }
      }
    );
  };

  //  written by sridhar on payeenmane change fun
  onPayeechange = (value) => {
    //console.log(value)
    if (value) {
      let updatedPayeenameList = [];
      if (
        !value.includes('{"Payeename":"Select All"}') &&
        this.state.selpayeename.includes('{"Payeename":"Select All"}')
      ) {
        updatedPayeenameList = [];
      } else if (
        !value.includes('{"Payeename":"Select All"}') &&
        value.length === this.state.payeenameList.length - 1
      ) {
        updatedPayeenameList = this.state.payeenameList.map((item) =>
          JSON.stringify(item)
        );
      } else if (
        this.state.selpayeename.includes('{"Payeename":"Select All"}') &&
        value.includes('{"Payeename":"Select All"}') &&
        value.length < this.state.payeenameList.length
      ) {
        updatedPayeenameList = value.filter(
          (item) => item != '{"Payeename":"Select All"}'
        );
      } else if (value.includes('{"Payeename":"Select All"}')) {
        updatedPayeenameList = this.state.payeenameList.map((item) =>
          JSON.stringify(item)
        );
      } else updatedPayeenameList = value;
      this.setState({
        selpayeename: updatedPayeenameList,
        enableGenrateButton: true,
      });
      //console.log("updatedPayeenameList",updatedPayeenameList)
      this.getProvidernameByclickOnPayeename(updatedPayeenameList);
      return updatedPayeenameList;
    }
    //this.getProviderNameList(updatedPayeenameList);
    else return this.state.selpayeename;
  };

  getProvidernameByclickOnPayeename = (value) => {
    //  console.log(this.state.selIpaNames.length)
    //  console.log(value)
    //  console.log("11111",this.state.selProviders)
    this.props.form.setFieldsValue({ providername: [] });
    this.setState({
      selProviders: [],
      providernameList: [],
      providerLoader: true,
    });
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
    };
    //  console.log("selIpaNames123",this.state.selIpaNames)
    //  console.log("selpayeename",this.state.selpayeename)
    let searchparam = [];
    let obj = {};
    let result = [];
    if (value !== undefined) {
      result = value
        .map(JSON.parse) // Parse each JSON string into an object
        .filter((obj) => obj.Payeename !== "Select All") // Filter out unwanted entry
        .map((obj) => {
          let value = obj.Payeename;
          // Add an additional single quote if there's already a single quote in the value
          if (value.includes("'")) {
            value = value.replace(/'/g, "''");
          }
          return {
            fieldName: "payeename",
            fieldValue: value,
          };
        });
    }

    console.log("ipaNameList 12312312", this.state.ipaNameList);
    console.log("selectedIapname3413413", this.state.selectedIapname);
    let selectesIPA;
    if (this.state.selectedIapname.length <= 0) {
      selectesIPA = "";
    } else {
      selectesIPA = this.state.selectedIapname
        .filter((item) => item !== undefined)
        .join(", ");
    }
    const searchParamsObj = {
      SearchParameters: result,
      PlanName: sessionStorage.getItem("planName"),
      MSOIds: selectesIPA,
      // MSOIds: this.state.selIpaNames.includes("Select All")
      //   ? this.state.selIpaNames
      //       .filter((val) => val != "Select All")
      //       .join(", ")
      //       .toString()
      //   : this.state.selIpaNames.join(", ").toString(),
      IsMSOSelectAll: this.state.selIpaNames.includes("Select All")
        ? true
        : false,
    };

    //const pName = sessionStorage.getItem("planName");
    axios
      .post(
        `${Config.Providerapi}/GetProviderBasedOnMSOID`,
        searchParamsObj,
        axiosConfig
      )
      .then((res) => {
        // console.log("res data111",res)
        let array = res.data.Details;
        let PayeenameList = array.map((item) => {
          return {
            Payeename: item.payeename,
          };
        });

        let uniquePayeenameList = [];
        let payeenameSet = new Set();

        PayeenameList.forEach((item) => {
          //console.log(item)
          if (!payeenameSet.has(item.Payeename) && item.Payeename !== null) {
            payeenameSet.add(item.Payeename);
            uniquePayeenameList.push({ Payeename: item.Payeename });
          }
        });

        uniquePayeenameList.unshift({ Payeename: "Select All" });
        //console.log("uniquePayeenameList",uniquePayeenameList)
        let newArray = array.map((item) => {
          return {
            npinumber: item.npinumber,
            FullName: `${item.firstname} ${item.lastname}`,
          };
        });
        //console.log("newArray",newArray)
        const uniqueList = [
          ...newArray
            .reduce((map, obj) => map.set(obj.npinumber, obj), new Map())
            .values(),
        ];
        //console.log("uniqueList",uniqueList)
        if (uniqueList.length > 1)
          uniqueList.splice(0, 0, {
            npinumber: "Select All",
            FullName: "Select All",
          });

        this.setState({
          providernameList: uniqueList,
          // payeenameList:uniquePayeenameList,
          providerLoader: false,
          showFound: true,
        });
      });
  };

  onProviderChange = (value) => {
      console.log("value 123",value)
    // debugger
    if (value) {
      let updatedList = [];
      const sSelectAll = '{"npinumber":"Select All","FullName":"Select All"}';
      if (
        (value[0] == sSelectAll && value.length == 1) ||
        (value[value.length - 1] == sSelectAll && value.length > 1)
      ) {
        // console.log("here 0");
        updatedList = [];
        updatedList = [sSelectAll];
      } else if (value[0] == sSelectAll && value.length > 1) {
        //console.log("here 02");
        updatedList = [];
        updatedList = value.filter((x) => x != sSelectAll);
      } else if (
        !value.includes('{"npinumber":"Select All","FullName":"Select All"}') &&
        this.state.selProviders.includes(
          '{"npinumber":"Select All","FullName":"Select All"}'
        )
      ) {
        updatedList = [];
      } else if (
        !value.includes('{"npinumber":"Select All","FullName":"Select All"}') &&
        value.length === this.state.providernameList.length - 1
      ) {
        updatedList = this.state.providernameList
          .filter((x) => x.npinumber != "Select All")
          .map((x) => JSON.stringify(x));
      } else if (
        this.state.selProviders.includes(
          '{"npinumber":"Select All","FullName":"Select All"}'
        ) &&
        value.includes('{"npinumber":"Select All","FullName":"Select All"}') &&
        value.length < this.state.providernameList.length
      ) {
        updatedList = value.filter(
          (item) => item != '{"npinumber":"Select All","FullName":"Select All"}'
        );
      } else if (
        value.includes('{"npinumber":"Select All","FullName":"Select All"}')
      ) {
        updatedList = this.state.providernameList;
      } else updatedList = value;
      this.setState({
        selProviders: updatedList,
        providerLoader: false,
      });
      //console.log("Provider Name",updatedList)
      return updatedList;
    } else return this.state.selProviders;
  };

  // onIpaNameChange = (value) => {
  //   console.log(value);
  //   return;
  //   this.setState({
  //     enableGenrateButton: true,
  //   });
  //   let updatedList = value;

  //   // since multiselect in ipa list is removed the below conditions are not required
  //   // if (
  //   //   !value.includes("Select All") &&
  //   //   this.state.selIpaNames.includes("Select All")
  //   // ) {
  //   //   updatedList = [];
  //   // } else if (
  //   //   !value.includes("Select All") &&
  //   //   value.length === this.state.ipaNameList.length - 1
  //   // ) {
  //   //   updatedList = this.state.ipaNameList;
  //   // } else if (
  //   //   this.state.selIpaNames.includes("Select All") &&
  //   //   value.includes("Select All") &&
  //   //   value.length < this.state.ipaNameList.length
  //   // ) {
  //   //   //updatedList = value
  //   //   updatedList = value.filter((item) => item != "Select All");
  //   // } else if (value.includes("Select All")) {
  //   //   updatedList = this.state.ipaNameList;
  //   // } else updatedList = value;

  //   this.setState(
  //     {
  //       providernameList: [],
  //       showFound: true,
  //       selIpaNames: updatedList,
  //       selProviders: [],
  //     },
  //     () => {
  //       this.props.form.setFieldsValue({ providername: [] });
  //       if (
  //         this.state.providernameList.length === 0 &&
  //         this.state.selIpaNames.length > 0
  //       )
  //         this.getProviderNameList(updatedList);
  //     }
  //   );
  //   return updatedList;
  // };

  // New code
  onIpaNameChange = (value) => {
    // console.log("value",value)
    // console.log("selpayeename", this.state.selpayeename)
    // console.log("selProviders", this.state.selProviders)
    if (typeof value == "string") {
      value = [value];
    }
    value = value.map((v) => v.toUpperCase());
    const sSelectAll = "SELECT ALL".toUpperCase();
    //console.log("Selected Value: ", value);

    this.setState({
      enableGenrateButton: value.length > 0 ? true : false,
    });
    let updatedList;
    // since multiselect in ipa list is removed the below conditions are not required
    if (
      (value[0] == sSelectAll && value.length == 1) ||
      (value[value.length - 1] == sSelectAll && value.length > 1)
    ) {
      // console.log("here 0");
      updatedList = [];
      updatedList = [sSelectAll];
    } else if (value[0] == sSelectAll && value.length > 1) {
      //console.log("here 02");
      updatedList = [];
      updatedList = value.filter((x) => x != sSelectAll);
    } else if (
      !value.includes(sSelectAll) &&
      this.state.selIpaNames.includes(sSelectAll)
    ) {
      //console.log("here 1");
      updatedList = value.filter((x) => x != sSelectAll);
    } else if (
      !value.includes(sSelectAll) &&
      value.length === this.state.ipaNameList.length - 1
    ) {
      //console.log("here 2");
      updatedList = value; //this.state.ipaNameList;
    } else if (
      this.state.selIpaNames.includes(sSelectAll) &&
      value.includes(sSelectAll) &&
      value.length < this.state.ipaNameList.length
    ) {
      //console.log("here 3");
      //updatedList = value
      updatedList = [];
      updatedList = value.filter((item) => {
        if (item.value != sSelectAll) {
          return item.value;
        }
      });
    } else if (value.includes(sSelectAll)) {
      //console.log("here 4");
      updatedList = value; //this.state.ipaNameList.map((ipa) => ipa.value);
    } else {
      // console.log("here 5");
      updatedList = value;
    }
    //updatedList = updatedList.filter((l) => l !== sSelectAll);
    //console.log("updated list", updatedList);
    this.setState(
      {
        providernameList: [],
        showFound: true,
        // payeeLoader:true,
        selIpaNames: updatedList,
        selProviders: [],
        payeenameList: [],
        selpayeename: [],
      },
      () => {
        this.props.form.setFieldsValue({ providername: [] });
        this.props.form.setFieldsValue({ payeename: [] });
        if (
          this.state.providernameList.length === 0 &&
          this.state.selIpaNames.length > 0
        )
          this.getProviderNameList(updatedList);
      }
    );
    return updatedList;
  };

  // sridhar code
  getipaNameList = async (isInitialLoad = false) => {
    this.setState({ isLoading: true, showFound: true });
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
    };
    let Roles = sessionStorage.getItem("rolename");
    let requestedNpis = [];

    if (Roles.includes("Provider")) {
      //console.log(" profiver if 2222222")
      let tempArr = JSON.parse(sessionStorage.getItem("npivalue"));
      requestedNpis.push(...tempArr);
    }
    if (Roles.includes("Group User") || Roles.includes("IPA User")) {
      let taxNpiMapping = JSON.parse(
        sessionStorage.getItem("rolename").includes("IPA User")
          ? sessionStorage.getItem("latestTaxidNpiMapping")
          : sessionStorage.getItem("taxidNpiMapping")
      );
      if (taxNpiMapping && taxNpiMapping.length > 0) {
        taxNpiMapping.map((item) => {
          if (item.NPI) {
            item.NPI.map((npi) => {
              if (!requestedNpis.includes(npi)) {
                requestedNpis.push(npi);
              }
            });
          }
        });
      }
    }
    // setState({ accessNpis: requestedNpis })
    let npis = [];
    const isGroupUser = Roles.includes("Group User");
    if ((!isInitialLoad || isGroupUser) && (sessionStorage.getItem("planName") !== "solis" || (!Roles.includes("IPA User") && !Roles.includes("Plan Admin")))) {
      axios
        .post(
          `${Config.api}/ListNPIBasedOnPlan?PlanName=${sessionStorage.getItem(
            "planName"
          )}`,
          { NpiNumber: requestedNpis },
          axiosConfig
        )
        .then((res) => {
          // setState({
          //   dataLoader: true
          // })
          let npiList = res.data.Details;
          let tempNameArr = {};
          let count = 0;
          for (var i = 0; i < npiList.length; i++) {
            if (npiList[i].providerType === "PCP") {
              let name = npiList[i].firstName
                ? `${npiList[i].firstName}${
                    npiList[i].middleName ? " " + npiList[i].middleName : ""
                  } ${npiList[i].lastName}`
                : npiList[i].facilityName;
              if (!tempNameArr[name]) {
                tempNameArr[name] = count;
                npis.push({
                  npinumber: npiList[i].npiNumber,
                  FullName: name,
                });
                count++;
              } else {
                npis[tempNameArr[name]].npinumber += "," + npiList[i].NPINumber;
              }
            }
          }
          if (npis.length > 1) {
            if (npis[0].FullName === npis[1].FullName) {
              let temp = npis.shift();
              npis[0].npinumber += "," + temp.npinumber;
            }
          }
          if (npis.length > 1)
            npis.splice(0, 0, {
              npinumber: "Select All",
              FullName: "Select All",
            });
            if (isGroupUser && this.state.selIpaNames.length > 0) {
              this.setState({ isLoading: false });
              return;
            }
          this.setState({
            providernameList: npis, //npis.map((i) => JSON.stringify(i)),
            isLoading: false,
            providerLoader: false,
          });
        })
        .catch((er) => {
          // console.log("er", er);
        });
    }
    const isSolisGroupUser =
      sessionStorage.getItem("planName") === "solis" &&
      Roles.includes("Group User");
    if (
      !Roles.includes("Provider") &&
      !isSolisGroupUser &&
      (
      sessionStorage.getItem("planName").includes("ultimate") ||
      sessionStorage.getItem("planName").includes("solis") ||
      sessionStorage.getItem("planName").includes("demo") ||  sessionStorage.getItem("planName").includes("csh") ||
      sessionStorage.getItem("planName").includes("secur")
      )
    ) {
      const planName = sessionStorage.getItem("planName");
      const ipaList =
        [sessionStorage.getItem("IPAList")] == ""
          ? []
          : sessionStorage
              .getItem("IPAList")
              .match(/(".*?"|[^,]+)(?=\s*,|\s*$)/g)
              .map(function (item) {
                return item.replace(/"/g, "");
              });
      let TaxidNPIFilter = {};
      if (sessionStorage.getItem("rolename").includes("Group User")) {
        let taxNpiMapping = JSON.parse(
          sessionStorage.getItem("taxidNpiMapping")
        );
        if (taxNpiMapping && taxNpiMapping.length > 0) {
          let taxIDs = [];
          let npis = [];
          taxNpiMapping.map((item) => {
            if (item.TaxID) {
              taxIDs.push(item.TaxID);
            }
            if (item.NPI) {
              item.NPI.map((npi) => {
                npis.push(npi);
              });
            }
          });

          TaxidNPIFilter["ProviderNPI"] = npis.join(",");
          TaxidNPIFilter["PCPTaxId"] = taxIDs.join(",");
        }
      }
      const res = await axios.post(
        Config.Providerapi + "/GetListofIPA",
        {
          PlanName: planName,
          IPAList: ipaList,
          TaxidNPIFilter: TaxidNPIFilter,
        },
        axiosConfig
      );
      // .then((res) => {
      //console.log(res);
      let array = res.data.IPADetails;

      let finalList = [];

      if (sessionStorage.getItem("planName") == "solis") {
        array.map((item) => {

          if (item.ipa && !finalList.includes(item.ipa.toUpperCase())) {
            if (item.msoid !== null) {

              finalList.push({

                ipaName: item.ipa.toUpperCase(),
                value: item.msoid,

              });
            }
          }
        });
      } else {
        array.map((item) => {
          if (item.ipa && !finalList.includes(item.ipa.toUpperCase())) {
            if (item.ipa !== null) {
              finalList.push({
                ipaName: item.ipa.toUpperCase(),
                value: item.ipa.toUpperCase(), // MSOID is only for SOLIS as of now
              });
            }
          }
        });
      }

      if (
        finalList.length > 1 
      ) {
        finalList.splice(0, 0, {
          ipaName: "Select All".toUpperCase(),
          value: "Select All".toUpperCase(),
        });
      }

      this.setState({
        ipaNameList: finalList,
        isLoading: false,
      });
      // })
      // .catch((err) => {
      //   console.log(err);
      // });
    }

    if (
      sessionStorage.getItem("planName").includes("solis") &&
       !sessionStorage.getItem("rolename").includes("Group User")
    ) {
      this.setState({
        payeeLoader: true,
      });
      console.log(" else if condition 1231212");
      let searchParams = [];
      const ipaList =
        [sessionStorage.getItem("IPAList")] == ""
          ? []
          : sessionStorage
              .getItem("IPAList")
              .match(/(".*?"|[^,]+)(?=\s*,|\s*$)/g)
              .map(function (item) {
                return item.replace(/"/g, "");
              });
      if (Roles.includes("Plan Admin")) {
        searchParams.push({
          fieldName: "cprstatus",
          fieldValue: "A",
        });
      }
      ipaList.forEach((ipa) => {
        searchParams.push({
          fieldName: "ipaname",
          fieldValue: ipa,
        });
      });
      axios
        .post(
          `${Config.Providerapi}/GetProviderBasedOnMSOID`,
          {
            SearchParameters: [...searchParams],
            PlanName: sessionStorage.getItem("planName"),
            IsMSOSelectAll: false,
            MSOIds: "",
          },
          axiosConfig
        )
        .then((res) => {
          //console.log("res data 222",res)
          let array = res.data.Details;
          let PayeenameList = array.map((item) => {
            return {
              Payeename: item.payeename,
            };
          });
          let uniquePayeenameList = [];
          let payeenameSet = new Set();
          PayeenameList.forEach((item) => {
            //console.log(item)
            if (!payeenameSet.has(item.Payeename) && item.Payeename !== null) {
              payeenameSet.add(item.Payeename);
              uniquePayeenameList.push({ Payeename: item.Payeename });
            }
          });

          uniquePayeenameList.unshift({ Payeename: "Select All" });
          // console.log("uniquePayeenameList",uniquePayeenameList)
          //let PayeenameList = [];
          let finalList = [];
          let newArray = array.map((item) => {
            return {
              npinumber: item.npinumber,
              FullName: `${item.firstname} ${item.lastname}`,
            };
          });
          //console.log("NewArray: ", newArray);
          const uniqueList = [
            ...newArray
              .reduce((map, obj) => map.set(obj.npinumber, obj), new Map())
              .values(),
          ];
          //console.log("uniqueList: ", uniqueList);
          array.map((item) => {
            if (
              item.ipaname &&
              !finalList.includes(item.ipaname.toUpperCase())
            ) {
              finalList.push({
                ipaName: item.ipa.toUpperCase(),
                value: item.msoid,
              });
            }
            PayeenameList.push({
              isPayeenameList: item.payeename,
            });
          });
          //console.log("PayeenameList",PayeenameList)
          if (uniqueList.length > 1)
            uniqueList.splice(0, 0, {
              npinumber: "Select All",
              FullName: "Select All",
            });
          // if (finalList.length > 1) finalList.splice(0, 0, "Select All")
          // console.log("finalList",finalList)
          this.setState(
            {
              providernameList: uniqueList,
              providerLoader: false,
              payeenameList: uniquePayeenameList,
              isLoading: false,
              showFound: true,
              payeeLoader: false,
            },
            () => {
              // console.log("Updated state: ", this.state.providernameList);
              // console.log("loader: ", this.state.providerLoader);
            }
          );
        })
        .catch((err) => {
          this.setState({
            isLoading: false,
          });
          // console.log("Something went wrong...");
        });
    }
  };


  handleTabChange = (activeKey) => {
    // Validate current form
    this.setState({
      activeKeydata:activeKey
    })
    console.log("activeKey",activeKey)
    if(activeKey == 1){
      this.handleReset()
    } 
  };

  getProviderNameList = async (values) => {
    // console.log(values)
    // plan Admin, GU, IPA user
    // let ipaname = values ? values.filter((item) => item != "Select All") : []
    //console.log("Value passed to getProvderNameList", values);

    let Roles = sessionStorage.getItem("rolename");
    let requestedNpis = [];
    if (
      sessionStorage.getItem("planName") === "solis" &&
      Roles.includes("Provider")
    ) {
      this.setState({
        providerLoader: true,
      });
      let axiosConfig = {
        headers: {
          Authorization: sessionStorage.getItem("access_token"),
          Accept: "application/json",
          "Content-type": "application/json",
        },
      };
      //let Roles = sessionStorage.getItem("rolename");
      requestedNpis = [];

      if (Roles.includes("Provider")) {
        let tempArr = JSON.parse(sessionStorage.getItem("npivalue"));
        requestedNpis.push(...tempArr);
      }

      if (Roles.includes("Group User") || Roles.includes("IPA User")) {
        // console.log("IPAs", this.ipaNameList);
        let taxNpiMapping = JSON.parse(
          sessionStorage.getItem("rolename").includes("IPA User")
            ? sessionStorage.getItem("latestTaxidNpiMapping")
            : sessionStorage.getItem("taxidNpiMapping")
        );
        if (taxNpiMapping && taxNpiMapping.length > 0) {
          taxNpiMapping.map((item) => {
            if (item.NPI) {
              item.NPI.map((npi) => {
                if (!requestedNpis.includes(npi)) {
                  requestedNpis.push(npi);
                }
              });
            }
          });
        }
      }

      // setState({ accessNpis: requestedNpis })
      let npis = [];

      axios
        .post(
          `${Config.api}/ListNPIBasedOnPlan?PlanName=${sessionStorage.getItem(
            "planName"
          )}`,
          { NpiNumber: requestedNpis },
          axiosConfig
        )
        .then((res) => {
          // setState({
          //   dataLoader: true
          // })
          //console.log("afasdas", res);
         const npiList = res.data.Details || [];

         // Keep only PCP records with a valid NPI.
         // Deduplicate by NPI, because the API can return the same record multiple times.

         const uniqueNpis = new Map();

         npiList.forEach((item) => {
          if (
            item.providerType === "PCP" &&
            item.npiNumber != null &&
            String(item.npiNumber).trim() !== ""
            ) {
              const npi = String(item.npiNumber).trim();
              
              if (!uniqueNpis.has(npi)) {
                const name = item.firstName
                ? [
                  item.firstName,
                  item.middleName,
                  item.lastName,
                  ]
            .filter((part) => part && part.trim())
            .join(" ")
        : item.facilityName;

      uniqueNpis.set(npi, {
        npinumber: npi,
        FullName: name || npi,
      });
    }
  }
});

const npis = Array.from(uniqueNpis.values());

// Preserve the existing Select All functionality.
          if (npis.length > 1) {
            npis.unshift({
              npinumber: "Select All",
              FullName: "Select All",
            });
          }
          this.setState({
            providernameList: npis,
            providerLoader: false,
          });
          //     console.log("state 11111: ", this.state.providernameList);
          // console.log("loader 11111: ", this.state.providerLoader);
        })
        .catch((er) => {
          // console.log("er", er);
        });
      
    } else {
      let Roles = sessionStorage.getItem("rolename");
      // let ipaname = [values];
      let SearchParameters = [];
      // if (ipaname.length > 0 && !Roles.includes("Provider")) {
      //   ipaname.forEach((item) => {
      //     SearchParameters.push({
      //       fieldName: "ipaname",
      //       fieldValue: item,
      //     });
      //   });
      // }

      if (Roles.includes("Provider")) {
        if (sessionStorage.getItem("taxid")) {
          SearchParameters.push({
            fieldName: "taxid",
            fieldValue: JSON.parse(sessionStorage.getItem("taxid"))[0],
          });
        }
        SearchParameters.push({
          fieldName: "npinumber",
          fieldValue: JSON.parse(sessionStorage.getItem("npivalue"))[0],
        });
      }

      if (
        (Roles.includes("Group User") || Roles.includes("IPA User")) &&
        !values
      ) {
        let taxNpiMapping = sessionStorage
          .getItem("rolename")
          .includes("IPA User")
          ? sessionStorage.getItem("latestTaxidNpiMapping")
          : sessionStorage.getItem("taxidNpiMapping");
        if (taxNpiMapping) {
          for (let item of JSON.parse(taxNpiMapping)) {
            if (item.TaxID) {
              SearchParameters.push({
                fieldName: "taxid",
                fieldValue: item.TaxID,
              });
            }
            if (item.NPI && item.NPI.length > 0) {
              item.NPI.map((npi) => {
                SearchParameters.push({
                  fieldName: "npinumber",
                  fieldValue: npi,
                });
              });
            }
          }
        }
      }

      this.setState({
        providernameList: [],
        providerLoader: true,
        selProviders: [],
      });
      let axiosConfig = {
        headers: {
          Authorization: sessionStorage.getItem("access_token"),
          Accept: "application/json",
          "Content-type": "application/json",
        },
      };
      if (!values) {
        values = [];
      }
  
      // ===================== CHANGE 1 =====================
      // Old code used .map() which returned `undefined` for the "SELECT ALL" entry,
      // so an undefined ipaname could end up in the payload.
      // Now: use filter + map so only real IPA values remain.
      if (values.includes("SELECT ALL")) {
        values = this.state.ipaNameList
          .filter((x) => x.value !== "SELECT ALL")
          .map((x) => x.value);
      }
  
      // ===================== CHANGE 2 =====================
      // True when a Group User has picked IPA(s) in the "Group / IPA Name" dropdown
      // on a non-solis plan (e.g. ultimate). In that case we must call the Search API
      // and must NOT call getipaNameList() (which triggers ListNPIBasedOnPlan and GetListofIPA).
      const isGroupUserIpaSearch =
        Roles.includes("Group User") &&
        sessionStorage.getItem("planName") !== "solis" &&
        values.length > 0;
  
      // ===================== CHANGE 3 =====================
      if (
        (Roles.includes("Group User") || Roles.includes("Provider")) &&
        !isGroupUserIpaSearch
      ) {
        await this.getipaNameList();
        //console.log("IPA Name List", this.state.ipaNameList);
        let searchParamsObj = {
          SearchParameters: SearchParameters,
          PlanName: sessionStorage.getItem("planName"),
          MSOIds:
            this.state.ipaNameList != undefined
              ? this.state.ipaNameList
                  .map((x) => x.value)
                  .join(", ")
                  .toString()
              : "",
          IsMSOSelectAll: false,
        };
      } else {
        if (sessionStorage.getItem("planName") == "solis") {
          // Remove the  null or undefined value
          const indexToRemove = values.findIndex((item) => item == null);
          if (indexToRemove !== -1) {
            values.splice(indexToRemove, 1);
          }
          this.setState({
            selectedIapname: values,
            payeeLoader: true,
          });
          let searchParamsObj = {
            SearchParameters: SearchParameters,
            PlanName: sessionStorage.getItem("planName"),
            MSOIds: values.includes("Select All")
              ? values
                  .filter((val) => val != "Select All")
                  .join(", ")
                  .toString()
              : values.join(", ").toString(),
            IsMSOSelectAll: values.includes("Select All") ? true : false,
          };
          let res = await axios.post(
            `${Config.Providerapi}/GetProviderBasedOnMSOID`,
            searchParamsObj,
            axiosConfig
          );

          // .then((res) => {
          //console.log("serach1", res);
          let array = res.data.Details;

          // console.log(array)
          let finalList = [];
          let PayeenameList = array.map((item) => ({
            Payeename: item.payeename,
          }));

          let uniquePayeenameList = [];
          let payeenameSet = new Set();

          PayeenameList.forEach((item) => {
            //console.log(item)
            if (!payeenameSet.has(item.Payeename) && item.Payeename !== null) {
              payeenameSet.add(item.Payeename);
              uniquePayeenameList.push({ Payeename: item.Payeename });
            }
          });

          uniquePayeenameList.unshift({ Payeename: "Select All" });
          //console.log("uniquePayeenameList",uniquePayeenameList)
          let newArray = array.map((item) => ({
            npinumber: item.npinumber,
            FullName: `${item.firstname} ${item.lastname}`,
          }));
          //console.log("NewArray: ", newArray);
          const uniqueList = [
            ...newArray
              .reduce((map, obj) => map.set(obj.npinumber, obj), new Map())
              .values(),
          ];

          if (uniqueList.length > 1)
            uniqueList.splice(0, 0, {
              npinumber: "Select All",
              FullName: "Select All",
            });

          if (uniqueList && uniqueList.length > 0) {
            this.setState({
              providernameList: uniqueList,
              providerLoader: false,
              payeeLoader: false,
              payeenameList: uniquePayeenameList,
              isLoading: false,
              showFound: true,
            });
          }
        } else {
          console.log("Other plans");

          // CHANGE 4: drop undefined/null so they never reach the payload
          let ipaname = values.filter((v) => v !== undefined && v !== null);
          let SearchParameters = [];
          if (ipaname.length > 0 && !Roles.includes("Provider")) {
            ipaname.forEach((item) => {
              SearchParameters.push({
                fieldName: "ipaname",
                fieldValue: item,
              });
            });
          }

          if (Roles.includes("Provider")) {
            if (sessionStorage.getItem("taxid")) {
              SearchParameters.push({
                fieldName: "ProviderTaxId",
                fieldValue: JSON.parse(sessionStorage.getItem("taxid"))[0],
              });
            }
            SearchParameters.push({
              fieldName: "npinumber",
              fieldValue: JSON.parse(sessionStorage.getItem("npivalue"))[0],
            });
          }

          // if (
          //   (Roles.includes("Group User") || Roles.includes("IPA User")) &&
          //   !values
          // ) {
          //   let taxNpiMapping = sessionStorage
          //     .getItem("rolename")
          //     .includes("IPA User")
          //     ? sessionStorage.getItem("latestTaxidNpiMapping")
          //     : sessionStorage.getItem("taxidNpiMapping");
          //   if (taxNpiMapping) {
          //     for (let item of JSON.parse(taxNpiMapping)) {
          //       if (item.TaxID) {
          //         SearchParameters.push({
          //           fieldName: "ProviderTaxId",
          //           fieldValue: item.TaxID,
          //         });
          //       }
          //       if (item.NPI && item.NPI.length > 0) {
          //         item.NPI.map((npi) => {
          //           SearchParameters.push({
          //             fieldName: "npinumber",
          //             fieldValue: npi,
          //           });
          //         });
          //       }
          //     }
          //   }
          // }

          this.setState({
            providernameList: [],
            providerLoader: true,
            selProviders: [],
          });
          let axiosConfig = {
            headers: {
              Authorization: sessionStorage.getItem("access_token"),
              Accept: "application/json",
              "Content-type": "application/json",
            },
          };
          axios
            .post(
              `${Config.Providerapi}/Search`,
              {
                SearchParameters: SearchParameters,
                PlanName: sessionStorage.getItem("planName"),
              },
              axiosConfig
            )
            .then((res) => {
              console.log("serach1", res);
              let array = res.data.Details.searchProviderDetailList;
              // console.log(array)
              let newArray = array.map((item) => ({
                npinumber: item.npinumber,
                FullName: item.fullName,
              }));
              // console.log(newArray)
              const uniqueList = [
                ...newArray
                  .reduce((map, obj) => map.set(obj.npinumber, obj), new Map())
                  .values(),
              ];
              // console.log(uniqueList)
              // array.map((item) => {
              //   if (item.FullName && !finalList.includes(item.FullName.toUpperCase())) {
              //     finalList.push(item.FullName.toUpperCase())
              //   }
              // })
              if (uniqueList.length > 1)
                uniqueList.splice(0, 0, {
                  npinumber: "Select All",
                  FullName: "Select All",
                });

              this.setState({
                providernameList: uniqueList,
                providerLoader: false,
                showFound: true,
              });
            })
            .catch((err) => {
              this.setState({
                providernameList: [],
                providerLoader: false,
                showFound: true,
              });
              console.log("Something went wrong...", err);
            });
        }
      }
    }
  };

  formatReport = () => {
    this.state.pcpReport.map((item) => {
      item.memberDOB = item.memberDOB
        ? moment(item.memberDOB).format("MM/DD/YYYY")
        : "";
      item.memberPCPEffectiveDate = item.memberPCPEffectiveDate
        ? moment(item.memberPCPEffectiveDate).format("MM/DD/YYYY")
        : "";
      item.memberPCPTerminationDate = item.memberPCPTerminationDate
        ? moment(item.memberPCPTerminationDate).format("MM/DD/YYYY")
        : "";
    });

    this.setState({
      pcpReport: this.state.pcpReport,
    });
  };
  downloadInPDF = async () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "in",
      format: [20, 10],
    });
    await this.formatReport();

    // Add your logo image
    let logoImage = new Image();
    let today = new Date();
    logoImage.src = UltimateLogo; // Provide the path to your logo image
    if(sessionStorage.getItem("planName") == "demo"){
     
      logoImage.src = mirranew; // Provide the path to your logo image
    }else{
    logoImage.src = UltimateLogo; // Provide the path to your logo image
    }
      console.log(logoImage)
    // from this.state.pcpReport removed pcpFirstName and pcpLastName
    let PdfBody = this.state.pcpReport.map((myObj) => {
      const { pcpFirstName, pcpLastName, pcP_ClinicName, payeeName, insuranceCompanyName, ...rest } =
        myObj;
      const rowData = Object.values(rest);
      if (sessionStorage.getItem("planName") === "solis") {
        rowData.push(payeeName); // Include Payee Name data if the plan is 'solis'
      }
      return rowData;
    });
    // Set up a header with an empty cell for the logo
    const header = [
      [
        "Member PCP Effective Date",
        "Member PCP Termination Date",
        "IPA Name",
        "Provider Name",
        "Member ID",
        "Member Last Name",
        "Member First Name",
        "Member DOB",
        "Address",
        "City",
        "State",
        "Zip",
        "Telephone",
        "Plan",
        "PCP ID",
        "PCP NPI ID",
        "PCP TAX ID",
        "PCP Address",
        "PCP City",
        "PCP State",
        "PCP Zip",
        "PCP County",
        ...(sessionStorage.getItem("planName") === "solis"
          ? ["Payee Name"]
          : []),
      ],
    ];

    if (sessionStorage.getItem("planName") == "ultimate" ||  sessionStorage.getItem("planName") == "demo") {
      doc.autoTable({
        head: header,
        body: PdfBody,
        startY: 0.7, // Adjust startY for the initial page
        didDrawPage: function (data) {
          // Adjust the x-coordinate to position the image more to the left
          const imageXPosition = data.settings.margin.right - 0.01; // Adjust the value as needed
          doc.addImage(logoImage, "PNG", imageXPosition, 0.1, 0.4, 0.4);
          // Add today's date with 12 font size and gray color
          const formattedDate = `${(today.getMonth() + 1)
            .toString()
            .padStart(2, "0")}-${today
            .getDate()
            .toString()
            .padStart(2, "0")}-${today.getFullYear()}`;
          const textWidth =
            (doc.getStringUnitWidth(`Date: ${formattedDate}`) * 12) /
            doc.internal.scaleFactor;
          const xPosition = (doc.internal.pageSize.getWidth() - textWidth) / 2; // Centering the text
          //console.log(xPosition);
          doc.setTextColor(105, 105, 106); // Set color to gray
          doc.setFontSize(12); // Set font size to 12
          doc.text(
            `Date: ${formattedDate}`,
            18.0,
            data.settings.margin.top - 0.2
          );
        },
      });
    } else {
      doc.autoTable({
        head: header,
        body: PdfBody,
      });
    }
    doc.save("Report.pdf");
  };

  downloadInExcel = async () => {
    await this.formatReport();
    this.props.form.resetFields();

    let option = {};

    let dataTable = this.state.pcpReport.map((item) => {
      // Create a copy of the item
      let newItem = { ...item };

      // Remove pcpFirstName and pcpLastName
      delete newItem.pcpFirstName;
      delete newItem.pcpLastName;
      delete newItem.pcP_ClinicName;
      delete newItem.insuranceCompanyName;
      // Conditionally add Payee name

      if (sessionStorage.getItem("planName") !== "solis") {
        // Remove and add Payee Name at last
        // let payeeName = newItem.payeeName;
        delete newItem.payeeName;
        // newItem["payeeName"] = payeeName;
      }

      if (sessionStorage.getItem("planName") == "solis") {
        // Remove and add Payee Name at last
        let payeeName = newItem.payeeName;
        delete newItem.payeeName;
        newItem["payeeName"] = payeeName;
      }

      return newItem;
    });

    option.fileName = "Report";
    option.datas = [
      {
        sheetData: dataTable,
        sheetName: "PCP Panel Report",
        sheetHeader: [
          "Member PCP Effective Date",
          "Member PCP Termination Date",
          "IPA Name",
          "Provider Name",
          "Member ID",
          "Member Last Name",
          "Member First Name",
          "Member DOB",
          "Address",
          "City",
          "State",
          "Zip",
          "Telephone",
          "Plan",
          "PCP ID",
          "PCP NPI ID",
          "PCP TAX ID",
          "PCP Address",
          "PCP City",
          "PCP State",
          "PCP Zip",
          "PCP County",
          ...(sessionStorage.getItem("planName") === "solis"
            ? ["Payee Name"]
            : []),
        ],
      },
    ];
    let toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  };

  selectDate = (date, dateString, type) => {
    if (type === "startDate") {
      this.setState({ startDate: dateString });
    }
    if (type === "endDate") {
      this.setState({ endDate: dateString });
    }
  };
  TicketShowInfo = () => {
    // console.log("Hiii");
    this.setState((state) => ({ TicketShow: true }));
  };
  TicketHideInfo = () => {
    this.setState((state) => ({ TicketShow: false }));
  };

  GetPcPPanelReport = () => {
    //  console.log("sdffdasdas")
    //  console.log(this.state.selpayeename)
    let requestedTaxID = [];
    let Roles = sessionStorage.getItem("rolename");
    if (Roles.includes("Group User") || Roles.includes("IPA User")) {
      let taxNpiMapping = JSON.parse(
        sessionStorage.getItem("rolename").includes("IPA User")
          ? sessionStorage.getItem("latestTaxidNpiMapping")
          : sessionStorage.getItem("taxidNpiMapping")
      );
      if (taxNpiMapping && taxNpiMapping.length > 0) {
        taxNpiMapping.map((item) => {
          if (item.TaxID) {
            requestedTaxID.push(item.TaxID);
          }
        });
      }
    }
    this.setState({
      reportLoading: true,
      pcpReport: null,
      currentPage: 1,
      totalrecored: 0,
      rowsPerPage: 15,
    });
    // let ipas = this.state.selIpaNames.filter((item) => item != "Select All")
    //old
    //let ipas = this.state.selIpaNames;
    //new after IPA Select Multiple
    let ipas = [];
    if (
      this.state.selIpaNames.includes("SELECT ALL")
    ) {
      ipas = this.state.ipaNameList
        .filter((ipa) => ipa.value != "SELECT ALL")
        .map((ipa) => ipa.ipaName) //.replace(/'/g, "''"))
        .join(" ~")
        .toString();
    } else {
      ipas = this.state.ipaNameList
        .filter((ipa) => this.state.selIpaNames.includes(ipa.value))
        .map((ipa) => ipa.ipaName) //.replace(/'/g, "''"))
        .join(" ~")
        .toString();
    }
    let providers = [];

const selectedProviders = this.state.selProviders || [];

if (
  selectedProviders.some((item) => {
    try {
      return JSON.parse(item).npinumber === "Select All";
    } catch {
      return false;
    }
  })
) {
  // Select All: take every unique NPI from the provider list.
  providers = (this.state.providernameList || [])
    .filter(
      (provider) => provider.npinumber && provider.npinumber !== "Select All"
    )
    .map((provider) => provider.npinumber);
} else {
  // Individual provider selection.
  providers = selectedProviders.flatMap((item) => {
    try {
      const provider = JSON.parse(item);

      return provider.npinumber ? String(provider.npinumber).split(",") : [];
    } catch {
      return [];
    }
  });
}

// Remove empty, undefined, invalid and duplicate NPI values.
providers = [
  ...new Set(
    providers
      .map((npi) => String(npi).trim())
      .filter((npi) => /^\d+$/.test(npi))
  ),
];

console.log("Final unique provider NPIs:", providers);

    //console.log("providers",providers)
    // Parse JSON strings and extract Payeename values
    const payeenames = this.state.selpayeename.map(
      (item) => JSON.parse(item).Payeename
    );
    // Filter out "Select All"
    const filteredPayeenames = payeenames.filter(
      (name) => name !== "Select All"
    );

    // Join the remaining values into a comma-separated string
    const commaSeparatedString = filteredPayeenames.join("~");

    //console.log(commaSeparatedString);

    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
    };
    let params = {
      ipaName: sessionStorage.getItem("IPAList").replaceAll('"', ""),
      pcpTaxId: requestedTaxID.join(),
      providerNPI: providers.join(),
      pcpEffectiveDate: this.state.startDate ? this.state.startDate : null,
      pcpTerminationDate: this.state.endDate ? this.state.endDate : null,
      PlanName: sessionStorage.getItem("planName"),
      payeeName: commaSeparatedString, //.replace(/'/g,"''"),
    };
    // if(sessionStorage.getItem('planName') !== 'solis')
    if (ipas == "") {
      params.ipaName = sessionStorage.getItem("IPAList").replaceAll('"', "");
    } else {
      params.ipaName = ipas;
    }
    axios
      .post(`${Config.api}/GetPcPPanelReport`, params, axiosConfig)
      .then((response) => {
        this.setState({
          pcpReport: response.data.pcpReportDetail,
          reportLoading: false,
        });
      })
      .catch((err) => {
        this.setState({
          reportLoading: false,
        });
      });
  };

  componentDidMount() {
    if (
      sessionStorage.getItem("rolename").includes("Provider") ||
      (sessionStorage.getItem("planName") !== "ultimate" &&
        sessionStorage.getItem("rolename").includes("Group User"))
    ) {
      this.setState({ GroupOrIpaField: false });
      this.getProviderNameList();
    } else {
      this.getipaNameList(true);
      //this.getProvidernameByclickOnPayeename()
    }
  }

  render() {
    //console.log("render",this.state.providernameList)
    const windowDimensions =
      "height=" + window.screen.height + ",width=" + window.screen.width;
    const TicketHideInfo = () => {
      this.setState((state) => ({ TicketShow: false }));
    };
    const warning = () => {
      modal.confirm({
        title: "Are you sure to cancel",
        content: "cancel will discard all the added data",
        onOk() {
          TicketHideInfo();
        },
        okText: "Yes, Cancel",
        cancelText: "No",
      });
    };
    const CancelButton = () => (
      <space wrap>
        <button className="button-cancel" onClick={warning}>
          Cancel
        </button>
      </space>
    );
    const Roles = sessionStorage.getItem("rolename")
      ? sessionStorage.getItem("rolename")
      : "";
    const { getFieldDecorator } = this.props.form ? this.props.form : "";
    const pcpReport = this.state.pcpReport;
    let renderRows = [];
    if (pcpReport && pcpReport[0]) {
      renderRows = pcpReport.map((rows, index) => {
        return rows;
      });
    }
    return (


      <Tabs id="AdminReport" defaultActiveKey="1"  onChange={this.handleTabChange}
      
      tabBarExtraContent={{
        right: (
          sessionStorage.getItem("planName") === "solis" && (
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              
              <button
                className="button-decorator-listuser button-text-color1 button-text-common"
                onClick={() => {
                  window.open(Config.OTC, "OTC Portal", windowDimensions);
                }}
              >
                OTC Portal
              </button>
    
              <button
                className="button-decorator-listuser button-text-color1 button-text-common"
                onClick={() => {
                  window.open(Config.CalypsoLite, "Calypso Lite", windowDimensions);
                }}
              >
                Calypso Lyte
              </button>
    
              <button
                className="button-decorator-listuser button-text-color1 button-text-common"
                onClick={() => {
                  window.open(
                    Config.EnsureDataSolutions,
                    "Ensure Data Solutions",
                    windowDimensions
                  );
                }}
              >
                Ensure Data Solutions
              </button>
    
              <button
                className="button-decorator-listuser button-text-color1 button-text-common"
                onClick={() => {
                  window.open(
                    Config.SolisHealthPlan,
                    "Solis Health Plan",
                    windowDimensions
                  );
                }}
              >
                Solis Health Plans
              </button>
    
            </div>
          )
        ),
      }}
      >
            
            <Tabs.TabPane tab="PCP Panel Report" key="1">
                <div>
        <Form>
          <div className="square-blue-profile-listuser-1">
            <Row
              className="ml-4"
              type="flex"
              justify-content="space-start"
              align="middle"
              style={{ padding: "6px" }}
            >
                {/* <Col>
                  <div
                    style={{
                      color: "white",
                      fontSize: "18px",
                      fontWeight: "bold",
                      paddingTop: "18px",
                      // width: "170px",
                    }}
                  >
                    PCP Panel Report
                    
                  </div>
                </Col> */}

              {/* {!this.state.TicketShow == true && (
                // <Row
                //   className="ml-4"
                //   // type="flex"
                //   // justify-content="space-start"
                //   // align="middle"
                //   style={{ marginLeft: "100px", padding: "0px"}}
                // >
                <Col push={16} className="ml-4">
                  <button
                    className="button-decorator-listuser button-text-color1 button-text-common"
                    //  className="button-decorator-listuser button-text-color1 button-text-common"
                    onClick={() => this.TicketShowInfo()}
                    label={"Create a Ticket"}
                  > Create a Ticket</button>
                </Col>

                // </Row>
              )} */}
              <Col
                push={sessionStorage.getItem("planName") === "solis" ? 9 : 18}
                className={"ml-4"}
              >
                {/* <NavLink to="/AddUser">
             </NavLink> */}
                
              </Col>
            </Row>
          </div>

          <div className="square-white-profile-listuser-1 mx-4 px-4 pt-2 pb-4">
            {/* <div className="square-white-profile-listuser ml-4 px-4 py-2" >
            <Row
              className=""
              type="flex"
              justify-content="space-start"
              align="bottom"
              style={{ padding: "10px" }}
            >
              <div
                className="pl-3"
                style={{
                  color: "#464F5D",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              > */}
            {this.state.TicketShow == true ? (
              <div>
                <CreateTicket
                  TicketHideInfo={this.TicketHideInfo}
                  Fromwhere={this.state.Fromwhere}
                />
              </div>
            ) : (
              <Row>
                {this.state.GroupOrIpaField &&
                  sessionStorage.getItem("planName") !== "solis" && (
                    <Col className="" span={6}>
                      <div className="addStaff-text">Group / IPA Name</div>
                      <Form.Item>
                        {getFieldDecorator("ipaname", {
                          getValueFromEvent: this.onIpaNameChange,
                        })(
                          <Select
                            maxTagTextLength={10}
                            size="small"
                            mode="multiple"
                            disabled={
                              sessionStorage.getItem("planName") === "solis"
                            }
                            //mode="multiple"
                            showSearch
                            style={{ width: "18vw" }}
                            placeholder="Select Group / IPA Name(s)"
                            // optionFilterProp="children"
                            value={this.state.selIpaNames}
                            //onChange={(e) => this.onIpaNameChange(e)}
                            className="removeInputBorder"
                            loading={this.state.isLoading}
                            notFoundContent={
                              <div className="nice-message">
                                {this.state.isLoading ? (
                                  <div>Loading....</div>
                                ) : (
                                  <div>No Data Found</div>
                                )}
                              </div>
                            }
                            filterOption={(input, option) =>
                              (option?.children ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          >
                            {this.state.ipaNameList &&
                              this.state.ipaNameList.map((item, idx) => {
                                if (item) {
                                  return (
                                    <Option
                                      key={idx}
                                      value={item.value}
                                      // style={{ textTransform: "capitalize" }}
                                    >
                                      {item.ipaName}
                                    </Option>
                                  );
                                }
                              })}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  )}

                {this.state.GroupOrIpaField &&
                  sessionStorage.getItem("planName") === "solis" && (
                    <>
                      <Col className="" span={4}>
                        <div
                          className="addStaff-text"
                          style={{ marginBottom: "5px" }}
                        >
                          IPA Name
                          {Roles.includes("Provider") && (
                            <span style={{ color: "red" }}> * </span>
                          )}
                        </div>
                        <Form.Item>
                          {getFieldDecorator("ipaname", {
                            getValueFromEvent: this.onIpaNameChange,
                            initialValue: [],
                          })(
                            <Select
                              maxTagTextLength={10}
                              size="small"
                              mode="multiple"
                              className="removeInputBorder Fixed-Height"
                              showSearch
                              style={{
                                width:
                                  sessionStorage.getItem("planName") === "solis"
                                    ? "14vw"
                                    : "18vw",
                              }}
                              placeholder="Select IPA Name"
                              // optionFilterProp="children"
                              //onChange={(e) => this.onIpaNameChange(e)}
                              loading={this.state.isLoading}
                              notFoundContent={
                                <div className="nice-message">
                                  {this.state.isLoading ? (
                                    <div>Loading....</div>
                                  ) : (
                                    <div>No Data Found</div>
                                  )}
                                </div>
                              }
                              filterOption={(input, option) =>
                                (option?.children ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                            >
                              {/* {<Option key="-1" value="Select All">
                                Select All
                              </Option>} */}
                              {this.state.ipaNameList &&
                                this.state.ipaNameList.map((item, idx) => {
                                  if (item) {
                                    return (
                                      <Option
                                        key={idx}
                                        value={item.value}
                                        // style={{ textTransform: "capitalize" }}
                                      >
                                        {item.ipaName}
                                      </Option>
                                    );
                                  }
                                })}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      {/* <Col className="" span={5}>
                        <div
                          className="addStaff-text"
                          style={{ marginBottom: "5px" }}
                        >
                          IPA Name
                          {Roles.includes("Provider") && (
                            <span style={{ color: "red" }}> * </span>
                          )}
                        </div>
                        <Form.Item>
                          {getFieldDecorator("ipaname", {
                            // getValueFromEvent: this.onIpaNameChange,
                          })(
                            <Select
                              maxTagTextLength={10}
                              size="small"
                              mode="multiple"
                              className="removeInputBorder Fixed-Height"
                              showSearch
                              style={{
                                width:
                                  sessionStorage.getItem("planName") === "solis"
                                    ? "16vw"
                                    : "18vw",
                              }}
                              placeholder="Select IPA Name"
                              // optionFilterProp="children"
                              onChange={(e) => this.onIpaNameChange(e)}
                              loading={this.state.isLoading}
                              notFoundContent={
                                <div className="nice-message">
                                  {this.state.isLoading ? (
                                    <div>Loading....</div>
                                  ) : (
                                    <div>No Data Found</div>
                                  )}
                                </div>
                              }
                            >
                              <Option key="-1" value="-1">
                                Select All
                              </Option>
                              {this.state.ipaNameList &&
                                this.state.ipaNameList.map((item, idx) => {
                                  if (item) {
                                    return (
                                      <Option
                                        key={idx}
                                        value={item}
                                        // style={{ textTransform: "capitalize" }}
                                      >
                                        {item.ipaName}
                                      </Option>
                                    );
                                  }
                                })}
                            </Select>
                          )}
                        </Form.Item>
                      </Col> */}
                      <Col className="" span={5} style={{ marginLeft: "32px" }}>
                        <div
                          className="addStaff-text"
                          style={{ marginBottom: "5px" }}
                        >
                          Payee Name
                          {Roles.includes("Provider") && (
                            <span style={{ color: "red" }}> * </span>
                          )}
                        </div>
                        <Form.Item>
                          {getFieldDecorator("payeename", {
                            getValueFromEvent: this.onPayeechange,
                            initialValue: [],
                          })(
                            <Select
                              maxTagTextLength={10}
                              size="small"
                              mode="multiple"
                              className="removeInputBorder Fixed-Height"
                              showSearch
                              style={{
                                width:
                                  sessionStorage.getItem("planName") === "solis"
                                    ? "14vw"
                                    : "18vw",
                              }}
                              placeholder="Select Payee Name(s)"
                              // optionFilterProp="children"
                              //onChange={(e) => this.onPayeechange(e)}
                              loading={this.state.payeeLoader}
                              notFoundContent={
                                <div className="nice-message">
                                  {this.state.payeeLoader ? (
                                    <div>Loading....</div>
                                  ) : (
                                    <div>No Data Found</div>
                                  )}
                                </div>
                              }
                            >
                              {this.state.payeenameList &&
                                this.state.payeenameList.map(
                                  (PAYENAME, idx) => {
                                    //  console.log(payeename)
                                    //console.log(idx)
                                    if (PAYENAME) {
                                      return (
                                        <Option
                                          key={idx}
                                          value={JSON.stringify(PAYENAME)}
                                        >
                                          {PAYENAME.Payeename}
                                        </Option>
                                      );
                                    }
                                  }
                                )}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                    </>
                  )}

                <Col
                  className=""
                  span={
                    sessionStorage.getItem("planName") === "solis" &&
                    Roles.includes("Provider")
                      ? 8
                      : sessionStorage.getItem("planName") === "solis"
                      ? 4
                      : 6
                  }
                >
                  <Tooltip
                    title={
                      Roles.includes("Provider") ||
                      (this.state.selIpaNames.length > 0
                        ? ""
                        : "Please select IPA name first" &&
                          sessionStorage.getItem("planName") !== "solis")
                    }
                    placement="topLeft"
                    align="left"
                  >
                    <div
                      className="addStaff-text"
                      style={{ marginBottom: "5px" }}
                    >
                      Provider Name
                      {Roles.includes("Provider") && (
                        <span style={{ color: "red" }}> * </span>
                      )}
                    </div>
                    <Form.Item>
                      {getFieldDecorator("providername", {
                        getValueFromEvent: this.onProviderChange,
                        initialValue: [],
                        //   rules: [
                        //     {
                        //       required: true,
                        //       message: (
                        //         <span className="errorMessage">
                        //           This field is mandatory
                        //         </span>
                        //       ),
                        //     },
                        //   ],
                      })(
                        <Select
                          maxTagTextLength={10}
                          size="small"
                          mode="multiple"
                          className="removeInputBorder Fixed-Height"
                          showSearch
                     //     disabled={this.state.GroupOrIpaField && this.state.selIpaNames.length === 0}
                          style={{
                            width:
                              sessionStorage.getItem("planName") === "solis"
                                ? "13vw"
                                : "18vw",
                          }}
                          placeholder="Select Provider Name(s)"
                          // optionFilterProp="children"
                          onChange={(e) => this.onProviderChange(e)}
                          loading={this.state.providerLoader}
                          notFoundContent={
                            <div className="nice-message">
                              {this.state.providerLoader ? (
                                <div>Loading....</div>
                              ) : (
                                <div>No Data Found</div>
                              )}
                            </div>
                          }
                          // filterOption={(input, option) =>
                          //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          // }
                        >
                          {this.state.providernameList &&
                            this.state.providernameList.length > 0 &&
                            this.state.providernameList.map((provider, idx) => {
                              if (provider) {
                                // console.log("Rendering provider: ", provider.FullName);
                                return (
                                  <Option
                                    key={idx}
                                    value={JSON.stringify(provider)}
                                  >
                                    {provider.FullName}
                                  </Option>
                                );
                              }
                            })}
                        </Select>
                      )}
                    </Form.Item>
                  </Tooltip>
                </Col>

                <Col
                  className=""
                  span={
                    sessionStorage.getItem("planName") === "solis" &&
                    Roles.includes("Provider")
                      ? 8
                      : sessionStorage.getItem("planName") === "solis"
                      ? 4
                      : 6
                  }
                >
                  <Tooltip
                    title={
                      Roles.includes("Provider") ||
                      (this.state.selIpaNames.length > 0
                        ? ""
                        : "Please select IPA name first" &&
                          sessionStorage.getItem("planName") !== "solis")
                    }
                    placement="topLeft"
                  >
                    <div className="addStaff-text">
                      Effective Start Date
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </div>
                    <Form.Item>
                      {getFieldDecorator("effectiveStartDate", {
                        initialValue: null,
                        rules: [
                          // {
                          //   required: true,
                          //   message: (
                          //     <span className="errorMessage">
                          //       This field is mandatory
                          //     </span>
                          //   ),
                          // },
                        ],
                      })(
                        <DatePicker
                          disabled={
                            Roles.includes("Provider") ||
                            (this.state.selProviders.length > 0 ||
                            this.state.selIpaNames.length > 0
                              ? false
                              : true &&
                                sessionStorage.getItem("planName") !== "solis")
                          }
                          size="small"
                          style={{
                            width:
                              sessionStorage.getItem("planName") === "solis"
                                ? "13vw"
                                : "18vw",
                          }}
                          onChange={(date, dateString) =>
                            this.selectDate(date, dateString, "startDate")
                          }
                          placeholder="Select Start Date"
                          format={"YYYY-MM-DD"}
                          className="removeInputBorder removeShadow"
                        />
                      )}
                    </Form.Item>
                  </Tooltip>
                </Col>

                <Col
                  className=""
                  span={
                    sessionStorage.getItem("planName") === "solis" &&
                    Roles.includes("Provider")
                      ? 8
                      : sessionStorage.getItem("planName") === "solis"
                      ? 4
                      : 6
                  }
                >
                  <Tooltip
                    title={
                      Roles.includes("Provider") ||
                      (this.state.selIpaNames.length > 0
                        ? ""
                        : "Please select IPA name first" &&
                          sessionStorage.getItem("planName") !== "solis")
                    }
                    placement="topLeft"
                    align="left"
                  >
                    <div className="addStaff-text">
                      Effective End Date
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </div>

                    <Form.Item>
                      {getFieldDecorator("effectiveEndDate", {
                        initialValue: null,
                        rules: [
                          // {
                          //   required: true,
                          //   message: (
                          //     <span className="errorMessage">
                          //       This field is mandatory
                          //     </span>
                          //   ),
                          // },
                        ],
                      })(
                        <DatePicker
                          disabled={
                            Roles.includes("Provider") ||
                            (this.state.selProviders.length > 0 ||
                            this.state.selIpaNames.length > 0
                              ? false
                              : true &&
                                sessionStorage.getItem("planName") !== "solis")
                          }
                          onChange={(date, dateString) =>
                            this.selectDate(date, dateString, "endDate")
                          }
                          style={{
                            width:
                              sessionStorage.getItem("planName") === "solis"
                                ? "15vw"
                                : "18vw",
                          }}
                          size="small"
                          placeholder="Select End Date"
                          className="removeInputBorder removeShadow"
                          format={"YYYY-MM-DD"}
                        />
                      )}
                    </Form.Item>
                  </Tooltip>
                </Col>
              </Row>
            )}
          </div>
          {!this.state.TicketShow == true && (
            <div>
              {(this.state.showFound ||
                sessionStorage.getItem("planName") === "solis") && (
                <div className="square-white-profile-listuser-nobg ml-4 p-0">
                  <Row className="p-0 py-1 custom_margin-x4">
                    <Col span={12}>
                      {pcpReport && (
                        <div>
                          <b>
                            {this.state.pcpReport &&
                            this.state.pcpReport.length > 9
                              ? pcpReport.length
                              : `0${pcpReport.length}`}{" "}
                            Members Found
                          </b>
                        </div>
                      )}
                    </Col>

                    {(sessionStorage.getItem("rolename").includes("Provider") ||
                      (this.state.selProviders &&
                        this.state.selProviders.length > 0) ||
                      this.state.enableGenrateButton == true) && (
                      <Col span={12} style={{ textAlign: "right" }}>
                        <div className="">
                          <PrimaryButton
                            className="delete-alluser danger pl-4 pr-4"
                            onClick={() => this.handleReset()}
                            label={"Reset"}
                          />
                          <PrimaryButton
                            className="button-alluser px-3 mx-1"
                            onClick={() => this.GetPcPPanelReport()}
                            label={"Generate Report"}
                          />
                        </div>
                      </Col>
                    )}
                  </Row>
                </div>
              )}
              {pcpReport && pcpReport.length > 0 ? (
                <div className="square-white-profile-listuser-1 ml-4 py-2 px-4">
                  <Row>
                    <Col className="p-0 tableOverflow">
                      <table className="table">
                        <thead>
                          <tr>
                            <th className="reportHeaderText">#</th>
                            <th className="reportHeaderText">
                              Member PCP Effective Date
                            </th>
                            <th className="reportHeaderText">
                              Member PCP Termination Date
                            </th>
                            <th className="reportHeaderText">IPA Name</th>
                            <th className="reportHeaderText">Provider Name</th>
                            <th className="reportHeaderText">Member ID</th>
                            <th className="reportHeaderText">
                              Member Last Name
                            </th>
                            <th className="reportHeaderText">
                              Member First Name
                            </th>
                            <th className="reportHeaderText">Member DOB</th>
                            <th className="reportHeaderText">Address</th>
                            <th className="reportHeaderText">City</th>
                            <th className="reportHeaderText">State</th>
                            <th className="reportHeaderText">Zip</th>
                            <th className="reportHeaderText">Telephone</th>
                            <th className="reportHeaderText">Plan</th>
                            <th className="reportHeaderText">PCP ID</th>
                            <th className="reportHeaderText">PCP NPI ID</th>
                            <th className="reportHeaderText">PCP TAX ID</th>
                            <th className="reportHeaderText">PCP Address</th>
                            <th className="reportHeaderText">PCP City</th>
                            <th className="reportHeaderText">PCP State</th>
                            <th className="reportHeaderText">PCP Zip</th>
                            <th className="reportHeaderText">PCP County </th>
                            {sessionStorage.getItem("planName") === "solis" && (
                              <>
                                <th className="reportHeaderText">Payee Name</th>
                              </>
                            )}
                          </tr>
                        </thead>
                        <tbody className="tdata">
                          {pcpReport &&
                            this.getpaginationData(
                              renderRows,
                              this.state.currentPage
                            ).map((item, index) => {
                              const rowNumber =
                                this.state.totalrecored + index + 1;
                              return (
                                <tr className="tdata">
                                  <td className="tdColor_idx">{rowNumber}</td>
                                  <td className="tdColor">
                                    {item.memberPCPEffectiveDate
                                      ? moment(
                                          item.memberPCPEffectiveDate
                                        ).format("MM/DD/YYYY")
                                      : ""}
                                  </td>
                                  <td className="tdColor">
                                    {item.memberPCPTerminationDate
                                      ? moment(
                                          item.memberPCPTerminationDate
                                        ).format("MM/DD/YYYY")
                                      : ""}
                                  </td>
                                  <td className="tdColor">{item.ipaName}</td>
                                  <td className="tdColor">
                                    {item.providerName}
                                  </td>
                                  <td className="tdColor">{item.memberID}</td>
                                  <td className="tdColor">
                                    {item.memberLastName}
                                  </td>
                                  <td className="tdColor">
                                    {item.memberFirstName}
                                  </td>
                                  <td className="tdColor">
                                    {item.memberDOB
                                      ? moment(item.memberDOB).format(
                                          "MM/DD/YYYY"
                                        )
                                      : ""}
                                  </td>
                                  <td className="tdColor">{item.address}</td>
                                  <td className="tdColor">{item.city}</td>
                                  <td className="tdColor">{item.state}</td>
                                  <td className="tdColor">{item.zip}</td>
                                  <td className="tdColor">{item.telephone}</td>
                                  <td className="tdColor">{item.plan}</td>
                                  <td className="tdColor">{item.pcpid}</td>
                                  <td className="tdColor">{item.pcpnpiid}</td>
                                  <td className="tdColor">{item.pcpTaxId}</td>
                                  <td className="tdColor">{item.pcpAddress}</td>
                                  <td className="tdColor">{item.pcpCity}</td>
                                  <td className="tdColor">{item.pcpState}</td>
                                  <td className="tdColor">{item.pcpzip}</td>
                                  <td className="tdColor">{item.pcpCounty}</td>
                                  {sessionStorage.getItem("planName") ===
                                    "solis" && (
                                    <td className="tdColor">
                                      {item.payeeName}
                                    </td>
                                  )}
                                </tr>
                              );
                            })}
                          <tr className="no-bg">
                            <td colspan="15">
                              <Row className="downloadTitle">
                                <Col span="6">
                                  <div>
                                    <span>
                                      <b>
                                        Download All{" "}
                                        {pcpReport
                                          ? this.state.pcpReport.length
                                          : "0"}{" "}
                                        Records
                                      </b>
                                    </span>
                                    <span></span>
                                  </div>
                                </Col>
                                <Col span="6">
                                  <div className="">
                                    <PrimaryButton
                                      className="button-alluser px-3 mx-1"
                                      onClick={this.downloadInPDF}
                                      label={"In PDF"}
                                    />
                                    <PrimaryButton
                                      className="button-alluser px-3 mx-1"
                                      onClick={this.downloadInExcel}
                                      label={"In Excel"}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      {renderRows.length > 15 && (
                        <div
                          style={{
                            width: "47vw",
                            display: "inline-block",
                            height: "3em",
                            marginTop: "18px",
                          }}
                        >
                          <Pagination
                            size="small"
                            hideOnSinglePage={true}
                            current={this.state.currentPage}
                            total={renderRows.length}
                            defaultPageSize={this.state.rowsPerPage}
                            showSizeChanger={false}
                            onChange={this.onPageChange}
                          />
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
              ) : null}
              {!this.state.reportLoading &&
              pcpReport != null &&
              pcpReport.length < 1 ? (
                <div className="blank-screen-placeholder">
                  <div>
                    <div className="centeredText">
                      <img
                        src={blackscreen}
                        style={{ height: "270px", width: "270px" }}
                      />
                    </div>
                    <div className="centeredText">
                      <div className="search-sreen-text">
                        Please Check The Parameter Again
                      </div>
                      <div className="search-sreen-text">Or</div>
                      <div className="search-sreen-text">
                        Search With Different Parameter
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {!this.state.reportLoading && pcpReport == null ? (
                <div className="mt-4">
                  <div>
                    <div className="centeredText">
                      <img
                        src={Report_Home}
                        style={{ height: "270px", width: "270px" }}
                      />
                    </div>
                    <div className="centeredText">
                      <div className="search-sreen-text">
                        Enter Details and Search To See The Results
                      </div>
                      <div className="search-sreen-text">Or</div>
                      <div className="search-sreen-text">
                        Search With Different Parameter
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {this.state.reportLoading && (
                <Row
                  style={{
                    textAlign: "center",
                    marginTop: "30vh",
                  }}
                >
                  <Spin size="large" />
                </Row>
              )}
            </div>
          )}
        </Form>
      </div>
      </Tabs.TabPane>
            


     
      <Tabs.TabPane tab="Provider Roster Report" key="2">
    <div>
      <Rosterreport   activeTab={this.state.activeKeydata} ipaNameList={this.state.ipaNameList}/>
    </div>
  </Tabs.TabPane>
{/* 
{ sessionStorage.getItem("planName") == "ultimate" &&(
   <Tabs.TabPane tab="Additional Report" key="4" >
    <div>
      <AdditionalReports   activeTab={this.state.activeKeydata} />
    </div>
  </Tabs.TabPane>
  )}     */}
      </Tabs>
    );
  }
}

export default Form.create({ name: "Reports" })(Reports);
